export const initialUser: User = {
  id: -1,
  email: '',
  name: '',
  kategori: null,
  role: {
    name: '',
    slug: '',
    permissions: [],
  },
  authorization: {
    token: null,
    type: null,
  },
};
